import { replaceWithNonbreakableSpaces } from '~/utils';

export const distancePrefix = (distance) => {
  const prefix = distance === 1 ? 'mile' : 'miles';
  return `${distance} ${prefix}`;
};

export const buildSearchResultTitle = (storeSearchQuery, title = 'Select a shop near') =>
  `${title}\u00A0\u2018${replaceWithNonbreakableSpaces(storeSearchQuery)}\u2019`;
